'use client';

import { useScrollReveal } from '@/hooks/useScrollReveal';

interface ProcessStep {
  step: string;
  title: string;
  description: string;
}

export default function ProcessTimeline({ steps }: { steps: ProcessStep[] }) {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.2 });

  return (
    <div ref={ref as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 gap-8 md:grid-cols-4">
      {steps.map((item, index) => (
        <div key={index} className="relative text-center">
          {/* Connector line — animated draw */}
          {index < steps.length - 1 && (
            <div
              className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-gradient-to-r from-[#2813e8] to-[#2cc3d1] origin-left transition-transform duration-700 ease-out"
              style={{
                transform: isVisible ? 'scaleX(1)' : 'scaleX(0)',
                transitionDelay: isVisible ? `${index * 200}ms` : '0ms',
              }}
            />
          )}
          {/* Step circle — stagger reveal */}
          <div
            className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-[#2813e8] to-[#2cc3d1] text-xl font-bold text-white shadow-lg cursor-default transition-all duration-500 ease-out"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'scale(1)' : 'scale(0.8)',
              transitionDelay: isVisible ? `${index * 150}ms` : '0ms',
            }}
          >
            {item.step}
          </div>
          {/* Text — stagger */}
          <div
            className="transition-all duration-500 ease-out"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(16px)',
              transitionDelay: isVisible ? `${index * 150 + 100}ms` : '0ms',
            }}
          >
            <h3 className="mt-6 text-xl font-semibold text-gray-900" id={item.title.toLowerCase()}>{item.title}</h3>
            <p className="mt-2 text-gray-600">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
